export enum DisturbanceType {
  Planned = 'Planned',
  Unplanned = 'Unplanned',
  Delivery = 'Delivery',
  Unknown = 'Unknown'
}
